export const environment = {
  production: false,
  apiBaseUrl: '/api' // برای توسعه
};
